<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
  getCarTypeList,
} from 'api';
import {mapState} from 'vuex';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        // 车辆种类
        vehicleClassOptions: [],
        // 归属部门
        orgIdOptions: [],
        // 车辆类型
        vehicleStatusOptions: [],
        form: [
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 主驾姓名
            label: '主驾姓名',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入主驾姓名',
          },
          { // 主驾手机
            label: '主驾手机',
            value: 'mobilePhone',
            type: 'input',
            placeholder: '请输入主驾手机',
          },
          { // 归属车队
            label: '归属车队',
            value: 'tenantName',
            type: 'input',
            placeholder: '请输入归属车队',
          },
          { // 车队手机
            label: '车队手机',
            value: 'linkPhone',
            type: 'input',
            placeholder: '请输入车队手机',
          },
          { // 车辆种类
            label: '车辆种类',
            value: 'vehicleClass',
            type: 'select',
            default: -1,
            placeholder: '车辆种类',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            placeholder: '请输入归属部门',
          },
          { // 车辆类型
            label: '车辆类型',
            value: 'vehicleStatus',
            type: 'cascader',
            normal: true,
            default: [],
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      searchBoxData.recordType = 1;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'VEHICLE_CLASS',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.vehicleClassOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(0),
    ];
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...((await getDepartmentAllList({
        isArchive: true,
      })) || []),
    ];
    this.searchBoxData.vehicleStatusOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...((await getCarTypeList()) || []),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
